import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../common/RootState.type'

export type LoggedInUser = {
  id: number
  username: string
  role: number
  contactId: number
  userId: number
  companyName: string
  loginId: string
}

export const loggedinUser: LoggedInUser = {
  id: Infinity,
  username: '',
  role: Infinity,
  contactId: Infinity,
  userId: Infinity,
  companyName: '',
  loginId: '',
}

const csrfTokenExp = false
const hasCsrfToken = false

const initialState = { loggedinUser, csrfTokenExp, hasCsrfToken }

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    toggleCsrfState: (state) => {
      state.csrfTokenExp = !state.csrfTokenExp
    },

    setLoggedinUser: (state, action) => {
      state.loggedinUser = {
        id: Number(action.payload.id),
        username: action.payload.username,
        role: action.payload.role,
        contactId: action.payload.contactId,
        userId: action.payload.userId,
        companyName: action.payload.companyName,
        loginId: String(action.payload.loginId ?? ''),
      }
    },

    logoutUser: (state) => {
      state.loggedinUser = loggedinUser
    },

    setCsrfToken: (state) => {
      state.hasCsrfToken = true
    },

    deleteCsrfToken: (state) => {
      state.hasCsrfToken = false
    },
  },
})


export const selectRole = (state: RootState) => state.auth.loggedinUser.role
export const selectLoggedInUser = (state: RootState) => state.auth.loggedinUser
export const selectLoginId = (state: RootState) => state.auth.loggedinUser.loginId

export const { toggleCsrfState, setLoggedinUser, logoutUser } =
  authSlice.actions
